import { Action, combineReducers } from '@ngrx/store';
import { objDiff } from '../utility';

import {
  _CLEAR,
  CREATE_SCRAP,
  CREATE_SCRAPS,
  DELETE_SCRAP,
  GET_ACTIVE_SCRAPS,
  GET_SCRAPS,
  SET_SCRAP_REPORT_VIEW,
  UPDATE_SCRAP,
  UPDATE_SCRAPS
} from '../actions';

const initialScrapReportViewState = {
  downloadingScrapReport: <boolean>false,
  loading: <boolean>false
};

export function activeScrapsReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    case CREATE_SCRAP:
      const match = state.find(scrap => action.payload.scrap && scrap.id === action.payload.scrap.id);
      return !match
        ? [ ...state, action.payload.scrap ].sort(sortScrap)
        : state;
    case DELETE_SCRAP:
      return state.filter(scrap => scrap.id !== action.payload.id);
    case GET_ACTIVE_SCRAPS:
      return [ ...action.payload.scraps ];
    case UPDATE_SCRAP:
      return state.map(scrap => {
        return scrap.id === action.payload.id
          ? objDiff(scrap, action.payload.diffList)
          : scrap;
      });
    default:
      return state;
  }
}

export function scrapReportViewReducer(state = initialScrapReportViewState, action: Action) {
  switch (action.type) {
    case _CLEAR:
      return state;
    case SET_SCRAP_REPORT_VIEW:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}

export function scrapListReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    case CREATE_SCRAP:
      return [ ...state, action.payload.scrap ].sort(sortScrap);
    case CREATE_SCRAPS:
      return [ ...state, ...action.payload.scraps ].sort(sortScrap);
    case DELETE_SCRAP:
      return state.filter(scrap => scrap.id !== action.payload.id);
    case GET_SCRAPS:
      return [ ...action.payload.scraps ];
    case UPDATE_SCRAP:
      return state.map(scrap => {
        return scrap.id === action.payload.id
          ? action.payload.scrap
          : scrap;
      });
    case UPDATE_SCRAPS:
      return state.map(stateScrap => {
        const match = action.payload.scraps.find(scrap => scrap.id === stateScrap.id);
        return !match ? stateScrap : match;
      });
    default:
      return state;
  }
}

function sortScrap(scrap1, scrap2): number {
  const date1 = new Date(+scrap1.createdAt);
  const date2 = new Date(+scrap2.createdAt);

  return +date1 - +date2;
}

export const scrapReducers = combineReducers({
  activeScraps: activeScrapsReducer,
  scrapReportView: scrapReportViewReducer,
  scrapList: scrapListReducer
});


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/ngrx/reducers/scrap.ts